import PaymentForm from "@/containers/payment-form";
import { Elements } from "@stripe/react-stripe-js";
import { PaymentStepProps } from "@/lib/types/checkout-steps";
import { StripeElementsOptions } from "@stripe/stripe-js";
import { stripePromise } from "@/lib/utils/stripe";
import { useMemo } from "react";
import { useLanguage } from "@/hooks/useLanguage";

const STRIPE_APPEARANCE = {
  theme: "stripe" as const,
  variables: {
    colorPrimary: "#5F955F",
    colorBackground: "#ffffff",
    colorText: "#202020",
    colorDanger: "#df1b41",
    fontFamily: "Rubik, ui-sans-serif, system-ui, sans-serif",
    spacingUnit: "4px",
    borderRadius: "6px",
  },
} as const;

export function PaymentStep({ isActive, onComplete, order }: PaymentStepProps) {
  const language = useLanguage();

  const stripeOptions: StripeElementsOptions = useMemo(
    () => ({
      mode: "setup",
      currency: "sek",
      payment_method_types: ["card"] as string[],
      locale: language === "en" ? "en" : "sv",
      appearance: STRIPE_APPEARANCE,
    }),
    [language]
  );

  const handleSuccess = (orderId: string) => {
    onComplete({ orderId });
  };

  if (!isActive) {
    return null;
  }

  return (
    <Elements stripe={stripePromise} options={stripeOptions}>
      <PaymentForm order={order} onSuccess={handleSuccess} isActive />
    </Elements>
  );
}
